import dateFormat from "dateformat";
import { createInputElement } from "../utils/input";
import { isMobile } from "../utils/detection";

const DateComponent = (el) => {
  const children = [...el.children];

  el.style.position = "relative";
  el.style.overflow = "hidden";

  children.forEach((child) => {
    child.style.position = "relative";
    child.style.userSelect = "none";
    child.style.zIndex = 1;
    child.style.pointerEvents = "none";
  });

  const min = new Date();
  min.setDate(min.getDate() + 1);

  const input = createInputElement({
    name: el.dataset.name || "date",
    type: "date",
    min: min.toISOString().split("T")[0],
    required: el.dataset.required === "true",
    value: el.querySelector("[data-value]").textContent,
  });

  if (el.dataset.id) input.id = el.dataset.id;
  if (el.dataset.name) input.setAttribute("data-name", el.dataset.name);

  input.addEventListener("change", (e) => {
    // add one day to target value to account for timezone differences
    const selectedDate = new Date(e.target.value);
    selectedDate.setDate(selectedDate.getDate() + 1);
    el.querySelector("[data-value]").textContent = dateFormat(
      selectedDate,
      "dddd, mmmm dS, yyyy",
    );
  });

  el.appendChild(input);

  if (!isMobile()) {
    input.style.opacity = 0;
    el.addEventListener("click", () => {
      input.showPicker();
    });
  }
};

export default DateComponent;
